import Api, { Cloud } from '@ambuliz/sabri-core';
import { useEffect, useState } from 'react';
import './App.css';
import reactLogo from './assets/react.svg';
import viteLogo from '/vite.svg';

function App() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    getUser();
  }, []);

  return (
    <>
      <div>
        <a href="https://vitejs.dev" target="_blank">
          <img src={viteLogo} className="logo" alt="Vite logo" />
        </a>
        <a href="https://react.dev" target="_blank">
          <img src={reactLogo} className="logo react" alt="React logo" />
        </a>
      </div>
      <h1>Vite + React</h1>
      <div className="card">
        <button onClick={() => setCount((count) => count + 1)}>count is {count}</button>
        <p>
          Edit <code>src/App.tsx</code> and save to test HMR
        </p>
      </div>
      <p className="read-the-docs">Click on the Vite and React logos to learn more</p>
    </>
  );
}

async function getUser() {
  try {
    let user = Api.User.current();

    if (!user) {
      user = await Api.User.logIn('admin', 'foo');
    }
    console.log(user);

    console.log(
      'Cloud.getAnsOrganizations',
      await Cloud.getAnsOrganizations({
        finessList: ['1234567890'],
      })
    );

    return user;
  } catch (error) {
    console.error(error);
  }
}

export default App;
